<template>
  <div>
    <!-- A票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.a_return_date"
          @dateChangedCallback="(date) => { manifest.a_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`a_return_date-${manifest.id}`"
              name="A票　返却日"
            >
              <v-text-field
                v-model="manifest.a_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="A票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('a_return_date', manifest.a_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`a_return_target-${manifest.id}`"
          name="A票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.a_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="A票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>A票　返却先</span>
              <span class="ml-1">
                ({{ manifest.a_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('a_return_target', manifest.a_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /A票 -->
    <!-- B2票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.b2_return_date"
          @dateChangedCallback="(date) => { manifest.b2_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`b2_return_date-${manifest.id}`"
              name="B2票　返却日"
            >
              <v-text-field
                v-model="manifest.b2_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="B2票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('b2_return_date', manifest.b2_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`b2_return_target-${manifest.id}`"
          name="B2票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.b2_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="B2票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>B2票　返却先</span>
              <span class="ml-1">
                ({{ manifest.b2_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template v-if="head && !solo" v-slot:append-outer>
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('b2_return_target', manifest.b2_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /B2票 -->
    <!-- B4票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.b4_return_date"
          @dateChangedCallback="(date) => { manifest.b4_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`b4_return_date-${manifest.id}`"
              name="B4票　返却日"
            >
              <v-text-field
                v-model="manifest.b4_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="B4票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('b4_return_date', manifest.b4_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`b4_return_target-${manifest.id}`"
          name="B4票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.b4_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="B4票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>B4票　返却先</span>
              <span class="ml-1">
                ({{ manifest.b4_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('b4_return_target', manifest.b4_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /B4票 -->
    <!-- B6票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.b6_return_date"
          @dateChangedCallback="(date) => { manifest.b6_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`b6_return_date-${manifest.id}`"
              name="B6票　返却日"
            >
              <v-text-field
                v-model="manifest.b6_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="B6票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('b6_return_date', manifest.b6_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`b6_return_target-${manifest.id}`"
          name="B6票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.b6_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="B6票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>B6票　返却先</span>
              <span class="ml-1">
                ({{ manifest.b6_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('b6_return_target', manifest.b6_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /B6票 -->
    <!-- D票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.d_return_date"
          @dateChangedCallback="(date) => { manifest.d_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`d_return_date-${manifest.id}`"
              name="D票　返却日"
            >
              <v-text-field
                v-model="manifest.d_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="D票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('d_return_date', manifest.d_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>

      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`d_return_target-${manifest.id}`"
          name="D票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.d_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="D票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>D票　返却先</span>
              <span class="ml-1">
                ({{ manifest.d_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('d_return_target', manifest.d_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /D票 -->
    <!-- E票 -->
    <v-row dense>
      <v-col cols="12" md="4">

        <cs-date-picker
          :date.sync="manifest.e_return_date"
          @dateChangedCallback="(date) => { manifest.e_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`e_return_date-${manifest.id}`"
              name="E票　返却日"
            >
              <v-text-field
                v-model="manifest.e_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="E票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('e_return_date', manifest.e_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`e_return_target-${manifest.id}`"
          name="E票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.e_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="E票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>E票　返却先</span>
              <span class="ml-1">
                ({{ manifest.e_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('e_return_target', manifest.e_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /E票 -->
    <!-- B1票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.b1_return_date"
          @dateChangedCallback="(date) => { manifest.b1_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`b1_return_date-${manifest.id}`"
              name="B1票　返却日"
            >
              <v-text-field
                v-model="manifest.b1_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="B1票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('b1_return_date', manifest.b1_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`b1_return_target-${manifest.id}`"
          name="B1票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.b1_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="B1票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>B1票　返却先</span>
              <span class="ml-1">
                ({{ manifest.b1_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('b1_return_target', manifest.b1_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /B1票 -->
    <!-- C1票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.c1_return_date"
          @dateChangedCallback="(date) => { manifest.c1_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`c1_return_date-${manifest.id}`"
              name="C1票　返却日"
            >
              <v-text-field
                v-model="manifest.c1_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="C1票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('c1_return_date', manifest.c1_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`c1_return_target-${manifest.id}`"
          name="C1票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.c1_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="C1票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>C1票　返却先</span>
              <span class="ml-1">
                ({{ manifest.c1_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('c1_return_target', manifest.c1_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /C1票 -->
    <!-- C2票 -->
    <v-row dense>
      <v-col cols="12" md="4">
        <cs-date-picker
          :date.sync="manifest.c2_return_date"
          @dateChangedCallback="(date) => { manifest.c2_return_date = date }"
        >
          <template v-slot="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :vid="`c2_return_date-${manifest.id}`"
              name="C2票　返却日"
            >
              <v-text-field
                v-model="manifest.c2_return_date"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="C2票　返却日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              >
                <template
                  v-if="head && !solo"
                  v-slot:append-outer
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    small
                    @click.stop="copyReturnTarget('c2_return_date', manifest.c2_return_date)"
                  >
                    複写
                  </v-btn>
                </template>
              </v-text-field>
            </validation-provider>
          </template>
        </cs-date-picker>
      </v-col>
      <v-col cols="12" md="8">
        <validation-provider
          v-slot="{ errors }"
          :vid="`c2_return_target-${manifest.id}`"
          name="C2票　返却先"
          rules="max:60"
        >
          <v-text-field
            v-model="manifest.c2_return_target"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="C2票　返却先"
            outlined
            persistent-placeholder
          >
            <template v-slot:label>
              <span>C2票　返却先</span>
              <span class="ml-1">
                ({{ manifest.c2_return_target?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
            <template
              v-if="head && !solo"
              v-slot:append-outer
            >
              <v-btn
                color="primary"
                class="mr-3"
                small
                @click="copyReturnTarget('c2_return_target', manifest.c2_return_target)"
              >
                複写
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /C2票 -->
  </div>
</template>

<script>

/**
 * @param manifest {Object}
 * @property manifest.a_return_date { String }
 * @property manifest.a_return_target { String }
 * @property manifest.b2_return_date { String }
 * @property manifest.b2_return_target { String }
 * @property manifest.b4_return_date { String }
 * @property manifest.b4_return_target { String }
 * @property manifest.b6_return_date { String }
 * @property manifest.b6_return_target { String }
 * @property manifest.d_return_date { String }
 * @property manifest.d_return_target { String }
 * @property manifest.e_return_date { String }
 * @property manifest.e_return_target { String }
 * @property manifest.b1_return_target { String }
 * @property manifest.c1_return_date { String }
 * @property manifest.c1_return_target { String }
 * @property manifest.c2_return_date { String }
 * @property manifest.c2_return_target { String }
 *
 */
export default {
  name: "PaperRegisterForm",
  comments: "紙マニフェスト",
  components: {},
  mixins: [],
  props: {
    /**
     * @param manifest { Object }
     * @param manifest.e_return_target { String }
     */
    manifest: {
      type: Object,
      default: () => null,
    },
    head: {
      type: Boolean,
      default: () => false
    },
    solo: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    copyReturnTarget(column, value) {
      if (value !== null && value !== "") {
        this.$emit('copyButtonCallback', column, value)
      }
    }
  }
}
</script>
